var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('PageHeaderUI',{attrs:{"title":"Book New Shipment","breadcrumb":"Dashboard > Bookings > New Booking Request"}}),_c('user-domains')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }